(() => {
  if (customElements.get('read-more')) {
    return;
  }

  class ReadMore extends HTMLElement {
    constructor() {
      super();
      this.maxDesktopRows =
        parseInt(this.getAttribute('data-desktop-max-rows')) || 10;
      this.maxMobileRows =
        parseInt(this.getAttribute('data-mobile-max-rows')) || 5;
      this.maxRows = this.maxDesktopRows;
      this.mobileBreakpoint = '(max-width: 750px)';
      this.contentWrapper = this.querySelector('[data-content-wrapper]');
      this.content = this.querySelector('[data-content]');
      this.contentHeight = 0;
      this.contentLineHeight = 0;
      this.button = this.querySelector('[data-button]');
    }

    connectedCallback() {
      this.attachEvents();
    }

    attachEvents() {
      ['load', 'scroll', 'resize'].forEach((eventName) => {
        window.addEventListener(eventName, this.init.bind(this));
      });

      this.button.addEventListener('click', this.toggle.bind(this));
    }

    init() {
      this.calcHeight();

      this.maxRows = window.matchMedia(this.mobileBreakpoint).matches
        ? this.maxMobileRows
        : this.maxDesktopRows;
      const currentRows = this.getRows();
      const maxHeight =
        this.maxRows > currentRows || !this.hasAttribute('open')
          ? this.contentLineHeight * this.maxRows
          : this.contentHeight;

      this.contentWrapper.style.height = `${this.contentHeight}px`;
      this.contentWrapper.style.maxHeight = `${maxHeight}px`;

      this.button.classList.toggle('hidden', this.contentHeight < maxHeight);
    }

    calcHeight() {
      const contentStyles = getComputedStyle(this.content);
      this.contentHeight = parseFloat(contentStyles.getPropertyValue('height'));
      this.contentLineHeight = parseFloat(
        contentStyles.getPropertyValue('line-height'),
      );
    }

    getRows() {
      return Math.round(this.contentHeight / this.contentLineHeight);
    }

    toggle() {
      const maxHeight = this.hasAttribute('open')
        ? this.contentLineHeight * this.maxRows
        : this.contentHeight;

      this.contentWrapper.style.maxHeight = `${maxHeight}px`;

      this.toggleAttribute('open');

      this.toggleBtn();
    }

    toggleBtn() {
      this.button.innerText = this.hasAttribute('open')
        ? window.variantStrings.readLess
        : window.variantStrings.readMore;
    }
  }

  customElements.define('read-more', ReadMore);
})();
